export interface UploadFileProps {
  file: File
  saveForLater?: boolean
  id: number
}

export const handleDuplicateFileNaming = (file: File, filesList: UploadFileProps[]) => {
  const newList = [...filesList]
  const baseName = file.name.split('.').slice(0, -1).join('.')
  const extension = file.name.split('.').pop()

  const fileNames = filesList.map((item) => item.file.name)

  const duplicatedNameFiles = fileNames.filter((item) => item.includes(file.name) || item.includes(baseName))

  const duplicatedExtensionNumbers = fileNames.filter((file) => file.includes(`(${duplicatedNameFiles.length})`))

  const duplicatedNumber =
    duplicatedExtensionNumbers.length > 0 ? duplicatedNameFiles.length + 1 : duplicatedNameFiles.length

  if (duplicatedNameFiles.length > 0) {
    newList.push({
      file: new File([file], `${baseName}(${duplicatedNumber}).${extension}`, {
        type: file.type,
      }),
      id: Date.now(),
    })
  } else newList.push({ file: file, id: Date.now() })
  return newList
}
